// extracted by mini-css-extract-plugin
export var select = "_qq-0";